import { createModalsFactory } from 'ui';

type ManageMyCausesModalIds = 'ManageCauses' | 'RemoveCause';

const { Provider: ManageMyCausesModalProvider, useProvider: useManageMyCausesModalProvider } =
  createModalsFactory<ManageMyCausesModalIds[]>(['ManageCauses', 'RemoveCause']);

export { ManageMyCausesModalProvider, useManageMyCausesModalProvider };
